export const CancelError = {
  data: 'cancel',
}
